/**
 * Created by rburson on 8/28/17.
 */
export class ArrayUtil {
    static copy(source) {
        return source.map((e) => {
            return e;
        });
    }
    static find(source, f) {
        let value = null;
        source.some((v) => {
            if (f(v)) {
                value = v;
                return true;
            }
            return false;
        });
        return value;
    }
}
